export default __webpack_public_path__ + "static/media/home_orange.6a900a31.svg";